import { Link } from "react-router-dom";
import JobKeyLogo from "./JobKeyLogo";
import LangSelect from "./LangSelect";
import { useAuth } from "@/context/AuthContext";
import { useI18n } from "@/i18n";
import { inr } from "@/lib/api";

export default function TopNav({ active = "" }) {
  const { user, logout } = useAuth();
  const { t } = useI18n();
  return (
    <header className="sticky top-0 z-40 border-b border-line/60 bg-bg/80 backdrop-blur-xl">
      <div className="mx-auto flex h-14 max-w-6xl items-center justify-between px-5">
        <div className="flex items-center gap-6">
          <Link to="/app" data-testid="topnav-logo"><JobKeyLogo /></Link>
          <nav className="hidden items-center gap-5 font-mono text-xs uppercase tracking-[0.15em] text-muted sm:flex">
            <Link to="/app" data-testid="topnav-app" className={active === "app" ? "text-accent" : "hover:text-accent"}>{t("App")}</Link>
            <Link to="/billing" data-testid="topnav-billing" className={active === "billing" ? "text-accent" : "hover:text-accent"}>{t("Billing")}</Link>
            {user?.role === "admin" && (
              <Link to="/admin" data-testid="topnav-admin" className={active === "admin" ? "text-accent" : "hover:text-accent"}>{t("Admin")}</Link>
            )}
          </nav>
        </div>
        <div className="flex items-center gap-2 sm:gap-3">
          <LangSelect />
          <span className="whitespace-nowrap rounded-full border border-line bg-surface px-3 py-1 font-mono text-xs" data-testid="topnav-wallet">
            ₹{((user?.wallet_balance || 0) / 100).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
          </span>
          <span className="hidden text-sm text-muted md:inline">{user?.name}</span>
          <button
            onClick={logout}
            data-testid="topnav-logout"
            className="rounded-full border border-line bg-surface px-4 py-1.5 text-sm font-bold text-ink transition-colors hover:border-accent hover:text-accent"
          >
            {t("Log out")}
          </button>
        </div>
      </div>
    </header>
  );
}
